export const iconFontAwesomeBuildingsChurch = (
	<i className="fa-solid fa-church"></i>
);
